import { useQuery } from '@tanstack/react-query';

// constants
import { BaseError } from '../../helpers/BaseError';

import { EventModel, EventStatus } from '../../models/event.model';

// services
import API from '../../services/api';

const getEvents = async (includeBlocked: boolean): Promise<EventModel[]> => {
    const { data } = await API.getTrackingEvents({
        include_blocked: includeBlocked,
    });
    return (data?.items || [])
        .map((item: EventModel) => {
            return {
                ...item,
                status:
                    item.attached_triggers_count > 0
                        ? EventStatus.Reserved
                        : item.is_imported
                        ? EventStatus.Imported
                        : EventStatus.Blocked,
            };
        })
        .sort((eventA: EventModel, eventB: EventModel) =>
            eventA.name.localeCompare(eventB.name),
        );
};

export default function useEventsQuery(filterBlocked: boolean = true) {
    return useQuery<EventModel[], BaseError>({
        queryKey: ['events', filterBlocked],
        queryFn: () => getEvents(!filterBlocked),
        staleTime: 1000 * 24 * 60 * 60,
    });
}
